import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom"
import $ from "jquery";
import moment from "moment";
import usePrevious from "../../../../class/tool/usePrevious";
import MenuDotIcon from "../../../icons/MenuDotIcon";
import CI5 from "../../../../image/ressource/glory/GLORY-Ci-5.jpg";
import CI10 from "../../../../image/ressource/glory/GLORY-Ci-10.jpg";
import CI10X from "../../../../image/ressource/glory/GLORY-Ci-10x.png";
import DashboardContext from "../../../../context/DashboardContext";
import "moment/locale/fr";
import ExportStats from "../analyze/ExportStats";
moment.locale('fr');

const Drawer = props => {
    const {automaticDrawer} = props;
    const { lastDrawerEvents } = useContext(DashboardContext);
    const [drawer, setDrawer] = useState({
        loading: automaticDrawer.loading,
        name: automaticDrawer.name,
        brand: automaticDrawer.brand,
        model: automaticDrawer.model,
        status: automaticDrawer.status
    });
    const [amountStacker, setAmountStacker] = useState(null);
    const [amountCassette, setAmountCassette] = useState(null);
    const [amountTotal, setAmountTotal] = useState(null);
    const [dateLastEvent, setDateLastEvent] = useState(null);
    const [options, setOptions] = useState(false);
    const [garanty, setGaranty] = useState(false);
    const prevAmountStacker = usePrevious(amountStacker);
    const prevAmountCassette = usePrevious(amountCassette);
    const prevAmountTotal = usePrevious(amountTotal);
    const LOG = false;
    const EVOL_PERCENT = 15;
    const history = useHistory();
    const idRandom = Math.floor(Math.random() * 999999);
    let onOptions = false;

    const initEvents = () => {
        if (automaticDrawer === undefined || automaticDrawer === null)
            return;

        getLastEvent();
        getLastInventory();
    }
    const getLastEvent = () => {
        if (automaticDrawer === undefined || automaticDrawer === null)
            return;

        automaticDrawer.getEvents(returnGetLastEvent, [], 1);
    }
    const returnGetLastEvent = (list, error, status) => {
        switch (status) {
            case 200:
                if (list.length > 0) {
                    for (let i in list) {
                        if (list[i].automatic_drawer_id === automaticDrawer.id) {
                            setDateLastEvent(list[i].created_at);
                            break;
                        }
                    }
                }

                break;
            default:
                console.error("LAST-EVENT-" + automaticDrawer.id, list, error, status);
                break;
        }
    }
    const getLastInventory = () => {
        if (automaticDrawer === undefined || automaticDrawer === null)
            return;

        automaticDrawer.getEvents(returnGetLastInventory, ["10", "15"], 1);
    }
    const returnGetLastInventory = (list, error, status) => {
        setDrawer(prev => ({
            ...prev,
            loading: false
        }));

        switch (status) {
            case 200:
                if (list.length > 0 && list[0].automatic_drawer_id === automaticDrawer.id)
                    explodeInventory(list[0].response);

                break;
            default:
                console.error("LAST-INVENTORY-" + automaticDrawer.id, list, error, status);
                break;
        }
    }
    const explodeInventory = response => {
        if (response === null)
            return;

        const inventory = automaticDrawer.explodeInventory(JSON.parse(response));

        try {
            setAmountStacker(inventory["stacker"]["total"]);
            setAmountCassette(inventory["cassette"]["total"]);
            setAmountTotal(inventory["total"]["total"]);
        }
        catch (e) {}
    }
    const explodeStatus = identifier => {
        const status = {
            "122": "ON",
            "121": "OFF",
            "120": "ERROR"
        };

        setDrawer(prev => ({
            ...prev,
            status: status[identifier]
        }));
    }
    const checkLastEvents = () => {
        if (lastDrawerEvents === null || lastDrawerEvents.length === 0)
            return;

        let events = lastDrawerEvents.filter(_ => _.automatic_drawer_id === automaticDrawer.id);
        let inventoryUpdated = false;
        let statusUpdated = false;

        events.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        if (events.length > 0 && dateLastEvent === null)
            setDateLastEvent(events[0].created_at);

        for (let i in events) {
            let event = events[i];

            if (["10", "11", "12", "15"].includes(event.identifier) && !inventoryUpdated) {
                inventoryUpdated = true;
                explodeInventory(event.response);
            }

            if (["120", "121", "122"].includes(event.identifier) && !statusUpdated) {
                statusUpdated = true;
                explodeStatus(event.identifier);
            }
        }
    }
    const buildState = () => {
        const textStatus = {
            "ON": "Connecté",
            "OFF": "Déconnecté",
            "ERROR": "Erreur"
        };

        return <div className={"containerState"}>
            {
                drawer.status !== null && <p className={"state " + drawer.status}>{textStatus[drawer.status]}</p>
            }
            <div id={"iconOptions" + idRandom} className={"options"} onClick={clickOnOptions}>
                <MenuDotIcon />
            </div>
        </div>;
    }
    const buildImg = () => {
        switch (drawer.brand.toLowerCase()) {
            case "glory":
                switch (drawer.model.toLowerCase()) {
                    case "ci-5": return <img className={"CI5"} src={CI5} alt={"Glory CI-5"} draggable={false} />;
                    case "ci-10": return <img className={"CI10"} src={CI10} alt={"Glory CI-10"} draggable={false} />;
                    case "ci-10x": return <img className={"CI10X"} src={CI10X} alt={"Glory CI-10X"} draggable={false} />;
                    default: break;
                }

                break;
            default: break;
        }
    }
    const buildLastUpdate = () => {
        if (dateLastEvent === null)
            return;

        return <p className={"since"}>{moment.utc(dateLastEvent).local().fromNow()}</p>;
    }
    const buildInventory = () => {
        if (drawer.loading) return;

        if (amountStacker === null || amountCassette === null || amountTotal === null) {
            return <div className={"inventory"}>
                <div className={"empty"}>
                    <p className={"text"}>Aucune information sur l'inventaire pour le moment ...</p>
                </div>
            </div>;
        }

        return <div className={"inventory"}>
            <div className={"bloc"}>
                <p className={"item"}>Recyclant</p>
                <p className={"value"} id={"amountStacker-" + automaticDrawer.id}><strong>0,00</strong>€</p>
            </div>
            <div className={"bloc"}>
                <p className={"item"}>Cassette</p>
                <p className={"value"} id={"amountCassette-" + automaticDrawer.id}><strong>0,00</strong>€</p>
            </div>
            <div className={"bloc total"}>
                <p className={"item"}>Total</p>
                <p className={"value"} id={"amountTotal-" + automaticDrawer.id}><strong>0,00</strong>€</p>
            </div>
        </div>;
    }
    const controlNumbers = () => {
        evolDecimal("amountStacker-" + automaticDrawer.id, amountStacker, prevAmountStacker);
        evolDecimal("amountCassette-" + automaticDrawer.id, amountCassette, prevAmountCassette);
        evolDecimal("amountTotal-" + automaticDrawer.id, amountTotal, prevAmountTotal);
    }
    const evolDecimal = (id, value, prevValue) => {
        let prev, delta, step, loop;

        if (value !== null && prevValue !== undefined && parseFloat(value) !== parseFloat(prevValue)) {
            try {
                loop = 1;
                prev = prevValue !== null ? prevValue : 0;
                delta = Math.abs(Math.round((parseFloat(value) - parseFloat(prev)) * 100) / 100);
                step = Math.round(((EVOL_PERCENT * delta) / 100) * 100) / 100;

                if (LOG) console.log(id, value, prev, delta, step);
                if (Math.abs(delta) === 0) return;

                if (parseFloat(value) >= parseFloat(prev)) {
                    for (let i = parseFloat(prev); i <= parseFloat(value); i = Math.round((i + step) * 100) / 100) {
                        if (i > parseFloat(value))
                            i = parseFloat(value);

                        setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(i)); }, loop*100);

                        loop++;
                    }

                }
                else {
                    for (let i = parseFloat(prev); i <= parseFloat(value); i = Math.round((i - step) * 100) / 100) {
                        if (i < parseFloat(value))
                            i = parseFloat(value);

                        setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(i)); }, loop*100);

                        loop++;
                    }
                }

                setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(parseFloat(value))); }, loop*100);
            }
            catch (error) {}
        }
    }
    const clickOn = () => {
        if (onOptions) return;

        setOptions(false);
        history.push("/dashboard/automaticdrawer/" + automaticDrawer.id);
    }
    const clickOnOptions = () => {
        onOptions = true;
        setOptions(!options);
    }
    const showOptions = () => {
        if (!options) return;

        const icon = $("#iconOptions" + idRandom);
        const overOptions = $(".overOptions.drawer." + idRandom);
        if (icon.length === 0 || overOptions.length === 0) return;

        const offset = icon.offset();

        overOptions.css({
            left: offset.left,
            top: (offset.top + icon.height() + 5),
        });
    }
    const clickOnExportGaranty = () => {
        onOptions = true;
        setGaranty(true);
    }
    const showGaranty = () => {
        onOptions = false;
        setOptions(false);
    }
    const closeGaranty = () => {
        setGaranty(false);
    }

    useEffect(() => {
        initEvents();
    }, [automaticDrawer]);
    useEffect(() => {
        checkLastEvents();
    }, [lastDrawerEvents]);
    useEffect(() => {
        controlNumbers();
    }, [amountStacker, amountCassette, amountTotal]);
    useEffect(() => {
        if (options)
            onOptions = false;

        showOptions();
    }, [options]);
    useEffect(() => {
        showGaranty();
    }, [garanty]);

    return(
        <>
            {
                garanty && <ExportStats type={"drawerEvents"} drawerId={automaticDrawer.id} cancel={closeGaranty} />
            }
            <div className={"module dual selectable drawer" + (drawer.loading ? " loading" : "")} onClick={clickOn}>
                <div className={"titleModule"}><p>{drawer.name}</p></div>
                <div className={"drawerState"}>
                    {buildState()}
                    {buildImg()}
                    {buildLastUpdate()}
                    {buildInventory()}
                </div>
                <div className={"overOptions drawer " + idRandom + (options ? " show" : "")}>
                    <nav className="options">
                        <p className="itemOption gray" onClick={clickOnExportGaranty}>Export pour l'assurance</p>
                    </nav>
                </div>
            </div>
        </>
    );
}

export default Drawer;